import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { compose } from 'redux';
import { Badge, CTA, HtmlRaw, Text } from '../../../ui/atoms';
import {
  Wrapper,
  CourseListContainer,
  PageGrid,
  Title,
  CategoryCard,
  CategoriesWrapper,
} from './style';
import { Container } from '../../../ui/gridSystem';
import { withMediaQueries } from '../../hoc/withMediaQueries';
import { StickyFiltersWrapper } from '../../../ui/atoms/CTA/style';
import { MODAL_OPEN } from '../../redux/actions';
import ModalCategories, {
  ModalCategoriesId,
} from '../../../ui/atoms/Modals/ModalCategories';
import ScormResults from './ScormResults';
import { SCORM_CATEGORIES_GET } from '../../redux/actions/scorm';

const ScormList = ({ mediaIsPhone, categories, getCategories, modalOpen }) => {
  const [currentArea, setCurrentArea] = useState({});

  useEffect(() => {
    window.scrollTo(0, 0);
    if (categories?.length <= 0) getCategories();
    return () => {
      setCurrentArea({});
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onClickCategory = (c) => {
    if (currentArea.id === c.id) setCurrentArea({});
    else setCurrentArea(c);
  };

  return (
    <>
      <Container>
        <Title>
          <Text type="h1" mb={mediaIsPhone ? 20 : 0}>
            Catalogo attività
          </Text>
        </Title>
        <Text type="b3" mb={32}>
          In questa pagina è possibile visualizzare, in base all’area tematica
          selezionata, la lista delle attività SCORM a cui il tutor è abilitato.
        </Text>
        <PageGrid>
          {mediaIsPhone ? (
            <StickyFiltersWrapper mb={16}>
              <CTA
                btnText="CAMBIA AREA TEMATICA"
                fullsize
                onClick={() =>
                  modalOpen(ModalCategoriesId, {
                    categories,
                  })
                }
              />
            </StickyFiltersWrapper>
          ) : (
            <div>
              <Text type="h2" className="pb-3 category-title">
                Area tematica
              </Text>
              <CategoriesWrapper>
                {(categories || []).map((c) => {
                  if (!c.scormsByCategory) return null;
                  return (
                    <CategoryCard
                      key={`category-${c?.id}`}
                      onClick={() => onClickCategory(c)}
                      className={currentArea.id === c?.id ? 'active' : ''}
                    >
                      <Text type="b3" className="label">
                        {c.label}
                      </Text>
                      {c?.scormsByCategory && (
                        <Badge
                          type="counter"
                          active={currentArea.id === c?.id}
                          notification={c?.hasNewScorms}
                        >
                          {c.scormsByCategory}
                        </Badge>
                      )}
                    </CategoryCard>
                  );
                })}
              </CategoriesWrapper>
            </div>
          )}
          <CourseListContainer>
            <Wrapper>
              <Text type="h1.5" mb={16}>
                {currentArea.label ?? 'Tutte le attività'}
              </Text>
              <Text type="b3">
                <HtmlRaw html={currentArea?.description || ''} />
              </Text>
              <ScormResults currentArea={currentArea} />
            </Wrapper>
          </CourseListContainer>
        </PageGrid>
      </Container>
      {mediaIsPhone && (
        <ModalCategories
          onClick={(category = {}) => setCurrentArea(category)}
        />
      )}
    </>
  );
};

ScormList.propTypes = {
  mediaIsPhone: PropTypes.bool,
  // HOC (connect, state)
  categories: PropTypes.array,
  // HOC (connect, dispatch)
  getCategories: PropTypes.func.isRequired,
  modalOpen: PropTypes.func.isRequired,
};

export default compose(
  connect(
    (state) => {
      const { categories } = state.scorm;
      return { categories };
    },
    (dispatch) => ({
      getCategories: (filters) =>
        dispatch({ type: SCORM_CATEGORIES_GET._REQUEST, filters }),
      modalOpen: (id, payload) => dispatch({ type: MODAL_OPEN, id, payload }),
    })
  ),
  withMediaQueries
)(ScormList);
